import React, { Component } from 'react';
// functions
import { scrollUp } from '../functions/functions'
// Images
import PerfectProducts from "../../assets/img/PerfectProductsHeb.png";
import Vi from "../../assets/video/Products.mp4";
// Animations
import { Animated } from "react-animated-css";
import Catalog from "./Catalog"
import { isMobile } from 'react-device-detect';


class Products extends Component {

    async componentDidMount() {
        this.props.changeScrollState(false, 'products')
        await scrollUp()
        await this.scrollEvent()
    }

    scrollEvent() {
        if (!this.props.state.menuScrolled && window.pageYOffset === 0) {
            window.addEventListener('scroll', this.chageParentSate)
        }
    }

    chageParentSate = () => {
        if (window.pageYOffset !== 0) {
            this.props.changeScrollState(true, 'products')
            window.removeEventListener('scroll', this.chageParentSate)
        }
    }

    componentWillUnmount() {
        console.log("unmount")
        this.props.changeScrollState(false, 'products')
    }

    render() {
        return (
            <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true}>

                <div className="PageHolder">
                    <div className="ContentHolder07">
                        {
                            !isMobile &&
                            <video className="Video01" loop={true} autoPlay>
                                <source src={Vi} type="video/mp4" />
                            </video>
                        }
                        <div className="OnVideo">
                            <div className="ImageHolder05">
                                <img src={PerfectProducts} alt="" className="Image02" />

                            </div>
                        </div>
                        <div className="ContentHolder08">
                            <div className="FirstContent">
                                <h1>הנאה לצד מקצועיות</h1>
                                <p className='rtlText'>

                                    במסגרת כמעט 100 שנות פעילות חברת עקיבא טולוצינסקי, השכלנו לבנות סל מוצרים המונה מאות מוצרים, איכותיים, אחידים ומדויקים אשר עומדים בתקנים המחמירים ביותר.
                                    המוצרים הללו, הנצרכים ברחבי הארץ על ידי החברות הגדולות ביותר במשק הישראלי וכמו כן במדינות רבות ברחבי העולם, קטלוג המוצרים שלנו, מציג היבט נוסף של הניסיון העצום שרכשנו, והוא מזוקק לתוך קטלוג מוצרים זה.
                                </p>
                            </div>

                        </div>
                        <div className="ProductsAndServiceConatainer">
                            <div >
                                <Catalog />
                            </div>
                        </div>
                    </div>


                </div>
            </Animated>
        );
    }
}

export default Products;



// WEBPACK FOOTER //
// ./src/components/pages/Products.js